import { BrandInfo, Page } from '../models';

const extractor = (
  pageHref: string,
  { author }: Page,
  { lang, brandName, siteUrl, logo }: BrandInfo
): object => ({
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': pageHref,
  },
  inLanguage: lang,
  author: {
    '@type': 'Person',
    name: author || brandName,
  },
  publisher: {
    '@type': 'Organization',
    name: brandName,
    url: siteUrl,
    ...(logo
      ? {
          logo: {
            '@type': 'ImageObject',
            url: logo,
          },
        }
      : {}),
  },
});

export default extractor;
